// extracted by mini-css-extract-plugin
module.exports = {"box":"DbB-MUR7l-kdUZmoWWBaFQ==","inline":"nvQ75gMj01hVU6tFPqlKaQ=="};